import React, { useState } from 'react';

import { TextField, CircularProgress, ClickAwayListener } from '@mui/material';

import Arrow from './Arrow';
import Close from './Close';
import LocationSearching from './LocationSearching';

import './location-search.styles.scss';



export default function LocationSearch({ handleSearch }) {
  const [terms, setTerms] = useState('');
  const [searchVisible, setSearchVisible] = useState(true);

  const [searchIsLoading, setSearchIsLoading] = useState(false);

  const handleChange = (event) => {
    setTerms(event.target.value);
  };

  const handleSearchExecution = async (event, text = null) => {
    if ((event.key === 'Enter' || text === 'search') && searchIsLoading === false) {
      setSearchIsLoading(true);
      await handleSearch(terms);
      setSearchVisible(false);
      setTerms('');
      setSearchIsLoading(false);
    }
  };

  const handleClickAway = () => {
    setSearchVisible(false);
  };

  const handleToggleOpen = () => {
    setSearchVisible(!searchVisible);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div
        id='search-container'
        className={searchVisible ? '' : 'search-hidden'}
      >
        <div id='search-icon' onClick={handleToggleOpen}>
          {searchVisible ? <Close /> : <LocationSearching />}
        </div>
        <TextField
          id='search-field'
          label='Address Search'
          variant='standard'
          size='small'
          placeholder='i.e. Ithaca, NY'
          inputMode='search'
          value={terms}
          onKeyDown={handleSearchExecution}
          onChange={handleChange}
          style={{ width: 'calc(100% - 20px)' }}
          InputProps={{
            endAdornment: (
              <>
                {searchIsLoading ? (
                  <CircularProgress color='inherit' size={20} />
                ) : null}
                {terms !== '' ? (
                  <div
                    id='enter-arrow'
                    onClick={(e) => handleSearchExecution(e, 'search')}
                  >
                    <Arrow/>
                  </div>
                ) : null}
              </>
            ),
          }}
        />
      </div>
    </ClickAwayListener>
  );
}